export const vendorRequestedTaxInfoBefore = 'You have already requested vendor tax information.';
